module.exports = __webpack_public_path__ + "img/item-curatorChat.9168c755.svg";